"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientActiveRequest = void 0;
var ClientActiveRequest = /** @class */ (function () {
    function ClientActiveRequest() {
    }
    return ClientActiveRequest;
}());
exports.ClientActiveRequest = ClientActiveRequest;
;
//# sourceMappingURL=clientActive.request.js.map